import { render, staticRenderFns } from "./ButtonInvoice.vue?vue&type=template&id=374ee7c2"
import script from "./ButtonInvoice.vue?vue&type=script&lang=js"
export * from "./ButtonInvoice.vue?vue&type=script&lang=js"
import style0 from "./ButtonInvoice.vue?vue&type=style&index=0&id=374ee7c2&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports